var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mustShow),expression:"mustShow"}],staticClass:"timelineElement",class:_vm.classOfElement},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.type)),_c('br'),_vm._v(" "+_vm._s(_vm.time)),_c('br'),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }